import axios from './axios'

export const getEngagementDashboardOverview = ({ from_date, to_date }) =>
  axios.get('/engagement_dashboard', {
    params: {
      from_date,
      to_date
    }
  })
